import { ReactElement } from 'react';
import NavSidebarSection from '../NavSidebarSection';
import Sparkles from '../../../../components/svg/Sparkles';
import { NavLink } from 'react-router-dom';
import { SidebarProps } from './SidebarProps';

const AgentsSidebarSection = (props: SidebarProps): ReactElement => {
  const { onNavClick } = props;

  const getCardBody = (): ReactElement => {
    return (
      <>
        <NavLink
          activeClassName="active-nav-link"
          onClick={onNavClick}
          to="/agents/explore"
        >
          <h4 className="sub-item">Agent Library</h4>
        </NavLink>
        <a
          href="https://sci-agents-demo-ucryjzut5a-uc.a.run.app/outputs"
          target="_blank"
        >
          <h4 className="sub-item">My Agents</h4>
        </a>
        {/* <NavLink
          activeClassName="active-nav-link"
          onClick={onNavClick}
          to="/agents/library"
        >
          <h4 className="sub-item">My Agents</h4>
        </NavLink> */}
      </>
    );
  };

  return (
    <NavSidebarSection
      cardBody={getCardBody()}
      eventKey="AGENTS"
      header="Agents"
      icon={<Sparkles height="18" width="18" />}
    />
  );
};

export default AgentsSidebarSection;
